"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
CardMobileController.$inject = ['$scope', '_card'];
function CardMobileController($scope, _card) {
    $scope.type = 0;
    $scope.sum = [];
    refreshData();
    function refreshData() {
        _card.getFinanceSum($scope.type).then(function (response) {
            $scope.sum = response;
            var dateObj = new Date(response.updated_at);
            var sum_date = dateObj.toLocaleDateString('sr-RS', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            var sum_date_time = dateObj.toLocaleTimeString('sr-RS', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
            $scope.sum.date = sum_date;
            $scope.sum.date_time = sum_date_time;
        }, function (error) {
        });
    }
    $scope.changeType = function (type) {
        if (type != $scope.type) {
            $scope.type = type;
            refreshData();
        }
    };
}
exports.CardMobileController = CardMobileController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/card/controllers/CardMobileController.js
// module id = 458
// module chunks = 0